import httpRequest from '../../utilities/js/httpRequest/httpRequest';
import navigationStore from '../../stores/navigation/NavigationStore';
import {CategoryTree} from '../../types/Navigation';

type NavigationResponseData = {
  children: CategoryTree[];
  currentElement: CategoryTree;
}

class NavigationService {
  private url = window.__globalConfig ? window.__globalConfig.apiUrls.navigation : '';

  loadCategories(categoryId: string = ''): Promise<{data: NavigationResponseData}> {
    return httpRequest.get(`${this.url}?categoryId=${categoryId}`);
  }


  // BurgerNavigation
  //////////////////////
  async loadCategoryLevel(categoryId: string, path: number[] = null) {
    const targetNode = this.findNodeByPath(path);

    if (categoryId !== undefined && targetNode.hasChildren && targetNode.subcategories.length === 0) {
      const response = await this.loadCategories(categoryId);
      if (path && response.data.children && response.data.children.length > 0) {
        targetNode.subcategories.push(...response.data.children);
        targetNode.teaser = response.data.currentElement.teaser || [];
      } else {
        // no path = root node
        navigationStore.navigationTree.push(...response.data.children);
        navigationStore.rootNodeProperties.teaser = response.data.currentElement.teaser || [];
      }
    } else {
      return Promise.resolve();
    }
  }

  findNodeByPath(path: number[]): CategoryTree {
    let pointer = this.createRootCategoryNode();
    if (path) {
      path.forEach((index) => {
        pointer = pointer.subcategories[index];
      });
    }
    return pointer;
  }

  findIndexPathByCategoryId(categoryId: string, navTree: CategoryTree[]): number[]|null {
    if (!categoryId) return null;

    let ndx = navTree.length;
    while (ndx--) {
      if (navTree[ndx].id == categoryId) {
        return [ndx];
      }
      else if (navTree[ndx].subcategories.length) {
        return [ndx, ...this.findIndexPathByCategoryId(categoryId, navTree[ndx].subcategories)];
      }
    }

    return null;
  }

  createRootCategoryNode(): CategoryTree {
    const rootNode = {
      name: '',
      url: '',
      id: 'root',
      icon: '',
      target: '',
      hasChildren: true,
      teaser: [],
      subcategories: navigationStore.navigationTree,
    }

    return {
      ...rootNode,
      ...navigationStore.rootNodeProperties
    }
  }
}

const navigationService = new NavigationService();
export {navigationService};
